
import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import { OrderAndDeliveryInventoryVO } from "@/views/biz/mypage/vo/mypage.vo";
import { OrderStatusOVO, MstOrderVO, RelOrderProductVO } from "@/views/biz/order/vo/order.vo";
import CommonUtils from "@/common-utils";

@Component
export default class OrderDeliveryInventory extends Vue {
  @Prop() tab!: string;
  param: OrderAndDeliveryInventoryVO = {} as OrderAndDeliveryInventoryVO;
  orderDeliveryInventoryGroupbyOrderList: Array<OrderAndDeliveryInventoryVO> | null = null; // 주문별 주문&배송 목록
  orderDeliveryInventoryProductList: Array<OrderAndDeliveryInventoryVO> = [] as Array<OrderAndDeliveryInventoryVO>; // 주문&배송 상품 목록
  orderStatusList: Array<OrderStatusOVO> = []; // 주문상태 별 카운팅

  orders: Array<MstOrderVO> = [];
  products: Array<RelOrderProductVO> = [];

  // Infinite scroll data
  isBusy = false;
  isInit = false;
  isLoad = false;

  orderStatusCountObject = {
    cd00401: 0,
    cd00402: 0,
    cd00403: 0,
    cd00404: 0,
  };

  // computed

  // method

  // orderCd와 orderStatusCd가 일치하는 상품정보 가져오기(상품준비 중은 제외)
  getProductsByOrderCd(orderCd: number, productType: string): Array<RelOrderProductVO> {
    const result: Array<RelOrderProductVO> = [];
    this.products.forEach((product) => {
      if (product.orderCd == orderCd && product.productType == productType) {
        result.push(product);
      }
    });
    return result;
  }

  // 상품 그룹(group by 하는게 의미 없어 상품 정보의 첫행만 가져옴)
  getProductGroupByOrderCd(orderCd: number, productType: string): Array<RelOrderProductVO> {
    const result = this.getProductsByOrderCd(orderCd, productType);
    return result && result.length ? [result[0]] : [];
  }

  // 같은 주문에 다른 상품 타입이 존재하는지 여부
  isMixedProductTypesByOrderCd(orderCd: number) {
    return this.getProductGroupByOrderCd(orderCd, "01").length && this.getProductGroupByOrderCd(orderCd, "02").length;
  }

  // 구매 확정 가능?
  canOrderConfirm(orderCd: number): boolean {
    let result = true;
    const tmp = this.products
      .filter((product) => {
        return product.orderCd == orderCd;
      })
      .forEach((product) => {
        if ((product.orderStatusCd.startsWith("00403") || product.orderStatusCd == "004040" || product.orderStatusCd == "004041") == false) {
          result = false;
          return;
        }
      });
    return result;
  }

  //=============================
  // 배송완료
  //    상태코드  |   일반상품            |    일반상품 현장픽업    |   홍콩상품    |   홍콩상품 현장픽업
  // 1. 004040    |   배송완료            |                       |   배송완료    |
  // 2. 004041    |                      |    픽업완료            |              |   픽업완료
  // 3. 004042    |   구매확정            |    구매확정            |   구매확정    |   구매확정
  //=============================

  //=============================
  // 상품준비중
  //=============================
  // 주문취소
  cancelOrder(item: OrderAndDeliveryInventoryVO): void {
    // 홍콩 상품(빠른배송)일 경우 주문취소 불가능
    // TODO 취소하기 페이지 이동
    this.$router.push({ name: "OrderClaimDetail", params: { claimType: "cancel", orderCd: item.orderCd.toString(), orderProductSeq: item.seq.toString() } });
  }

  // 주문 상세페이지로 이동
  orderDetail(orderCd: string) {
    this.$router.push({ name: "OrderDetails", params: { orderCd: orderCd } });
  }

  // 다시 구매
  repurchase(item: OrderAndDeliveryInventoryVO) {
    this.$router.push({ name: "Product", params: { productCd: String(item.productCd) } });
  }

  setGroupingByStatusCnt() {
    this.orderStatusList.forEach((row) => {
      this.orderStatusCountObject[`cd${row.orderStatusCd}`] += row.totCnt;
    });
  }
  // 송장
  searchDelivery(productGroup: RelOrderProductVO): void {
    // 송장번호가 있을 경우에만 실행(없으면 무반응)
    // TODO window.open으로 했으나 알아보고 변경해야 함
    // 중국
    if (productGroup.invcNo) {
      let url = "";
      if (CommonUtils.isSystemLocale("ko")) {
        url = productGroup.courierUrl + productGroup.invcNo;
      } else {
        url = productGroup.courierUrl + productGroup.invcNo;
      }
      window.open(url);
    }
  }

  // 결제
  payment(orderCd: string) {
    this.$router.push(`/order/payment/${orderCd}`);
  }

  // 더보기
  loadMore() {
    if (this.isInit == false) return;
    this.param.startNum += this.param.limitNum;
    this.selectOrders();
  }

  // 주문 목록
  selectOrders(): void {
    switch (this.tab) {
      case "all": // 전체
        break;
      case "product-preparation": // 상품 준비
        this.param.orderStatusCd = "00402";
        break;
      case "product-delivery": // 상품 배송
        this.param.orderStatusCd = "00403";
        break;
      case "delivery-complete": // 배송 완료
        this.param.orderStatusCd = "00404";
        break;
    }

    axios.get("/mypage/orders", { params: this.param }).then(
      (r) => {
        if (r.data && r.data.orders && r.data.products) {
          this.orders = this.orders.concat(r.data.orders);
          this.products = this.products.concat(r.data.products);
          this.isInit || (this.isInit = true);
          this.isBusy = false;
        } else {
          this.isBusy = true;
        }

        if (this.isLoad == false) {
          this.isLoad = true;
        }
      },
      () => {
        alert(this.$t("common.a0001"));
        this.isBusy = false;
      }
    );
  }

  // 뱃지 숫자
  getBadgeNumber(statusCd: string) {
    return this.orderStatusCountObject[statusCd] > 99 ? "99+" : this.orderStatusCountObject[statusCd];
  }

  isBadgeNumber(statusCd: string) {
    return this.orderStatusCountObject[statusCd] ? true : false;
  }

  // 초기화
  created() {
    // TODO 페이징 임시 제거(고장남 ㅠㅠ)
    // this.param.startNum = 0;
    // this.param.limitNum = 10;

    // 주문 목록
    this.selectOrders();
    // 주문상태별 카운팅(배지)
    axios.get("/order/status").then((r) => {
      this.orderStatusList = r.data;
      this.setGroupingByStatusCnt();
    });
  }
}
